module.exports = __webpack_public_path__ + "img/iconos-categorias-02.0d6cf7ba.svg";